var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-message"},[_c(_vm.illustration,{tag:"component"}),_vm._v(" "),_vm._t("default",function(){return [_c('h3',[_vm._v(_vm._s(_vm.errorTitle))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.errorDescription))])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }